import {
    Container,
    Sprite,
} from 'pixi.js';
import { Tween, Disposable, globals } from '../../utils';
import { ExtPromise } from './ExtPromise';
import { Discoverable } from './Discoverable';
import { GlowFilter } from '@pixi/filter-glow';

const GLOW = new GlowFilter({
    distance: 30,
    color: 0xffffff,
    outerStrength: 4
});

const GLOW_LOW = new GlowFilter({
    distance: 30,
    color: 0xffffff,
    outerStrength: 4,
    quality: 0.05
});

export class FindAnimation extends Container
{
    private found: Sprite;
    private perfListener: Disposable;

    public static preload()
    {
    }

    constructor()
    {
        super();

        this.found = new Sprite();
        this.found.anchor.set(0.5);
        this.found.filters = [globals.LOW_PERFORMANCE.value ? GLOW_LOW : GLOW];
        this.addChild(this.found);

        this.perfListener = Disposable.fromPropertySubscription(globals.LOW_PERFORMANCE, (val) => {
            this.found.filters = [val ? GLOW_LOW : GLOW];
        });

        this.visible = false;
    }

    public open(found: Discoverable)
    {
        this.found.texture = found.texture;

        const done = new ExtPromise();

        this.alpha = 0;
        this.scale.set(0.2);
        this.visible = true;
        Tween.get(this as FindAnimation).to({alpha: 1}, 400, 'quadOut').call(done.resolve);
        Tween.get(this.scale).to({x: 1, y: 1}, 400, 'bounceOut');

        return done.promise;
    }

    public close()
    {
        const done = new ExtPromise();
        Tween.get(this as FindAnimation).to({alpha: 0}, 250, 'quadIn').call(done.resolve);
        Tween.get(this.scale).to({x: 0.2, y: 0.2}, 250, 'quadIn');

        done.promise.then(() => {
            this.visible = false;
        });

        return done.promise;
    }

    public destroy()
    {
        // just to be safe, remove any running tweens
        Tween.removeTweens(this);
        Tween.removeTweens(this.scale);
        this.perfListener.dispose();
        super.destroy({children: true});
    }
}